import { ICellRendererParams } from '@mint-lib/ag-grid/community';
import { Skeleton, TruncateText } from '@mint-lib/tw-components';

import { ScheduleTableType } from '../../../../types/queryScheduler.js';

const MessageCell = ({ data }: ICellRendererParams<ScheduleTableType>) => {
  if (data?.__isSkeleton) {
    return <Skeleton />;
  }

  if (!data?.message) {
    return null;
  }

  return (
    <div className="flex h-full items-center">
      <TruncateText>{data.message}</TruncateText>
    </div>
  );
};

export { MessageCell };
